/**
 按钮点击限制(设置时间--函数节流)
 @param {Fun} callback 回调函数
 @param {Number} time 间隔时间
 */
const throttle = function (callback, time) {
    var startTime
    return function (...arg) {
        if (!startTime) {
            startTime = new Date().getTime()
            callback.call(this, arg)
        }
        if (new Date().getTime() - startTime > time) {
            startTime = new Date().getTime()
            callback.call(this, arg)
        }
    }
}
export default throttle
